import API from './API';
import URLSearchParams from 'url-search-params';
import TeamActions from 'actions/TeamActions';

const TeamSource = {
  getRemoteTeams: {
    remote(state) {
      const fetchUrl = API.getTeamList;
      const searchParams = new URLSearchParams();
      for(let k in state.params) {
        searchParams.append(k, state.params[k]);
      }
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: TeamActions.fetchSuccess,
    error: TeamActions.fetchError
  },
  getRemoteTeamStarts: {
    remote(state) {
      const fetchUrl = API.getTeamStartList;
      const searchParams = new URLSearchParams();
      for(let k in state.params2) {
        searchParams.append(k, state.params2[k]);
      }
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: TeamActions.fetchStartSuccess,
    error: TeamActions.fetchError
  }
};

export default TeamSource;



// WEBPACK FOOTER //
// ./src/sources/TeamSource.js